/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetCourseCompletionsReportAggregateByDayOptions, GetCourseCompletionsReportAggregateByDayStatus200, GetCourseCompletionsReportAggregateByDayStatus422 } from '../models/GetCourseCompletionsReportAggregateByDay'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getCourseCompletionsReportAggregateByDay } from '../clients/axios/getCourseCompletionsReportAggregateByDay'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCourseCompletionsReportAggregateByDayQueryKey = ({ query }: Omit<GetCourseCompletionsReportAggregateByDayOptions, 'headers'>) => [{ url: '/reports/course_completions/aggregate-by-day' }, ...(query ? [query] : [])] as const

type GetCourseCompletionsReportAggregateByDayQueryKey = ReturnType<typeof getCourseCompletionsReportAggregateByDayQueryKey>

export function getCourseCompletionsReportAggregateByDayQueryOptions({ query }: GetCourseCompletionsReportAggregateByDayOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getCourseCompletionsReportAggregateByDayQueryKey({ query })
  return queryOptions<GetCourseCompletionsReportAggregateByDayStatus200, ResponseErrorConfig<GetCourseCompletionsReportAggregateByDayStatus422>, GetCourseCompletionsReportAggregateByDayStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getCourseCompletionsReportAggregateByDay({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Course Completions Aggregate By Day
 * {@link /reports/course_completions/aggregate-by-day}
 */
export function useGetCourseCompletionsReportAggregateByDay<TData = GetCourseCompletionsReportAggregateByDayStatus200, TQueryData = GetCourseCompletionsReportAggregateByDayStatus200, TQueryKey extends QueryKey = GetCourseCompletionsReportAggregateByDayQueryKey>({ query }: { query: GetCourseCompletionsReportAggregateByDayOptions['query'] | (() => GetCourseCompletionsReportAggregateByDayOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<GetCourseCompletionsReportAggregateByDayStatus200, ResponseErrorConfig<GetCourseCompletionsReportAggregateByDayStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getCourseCompletionsReportAggregateByDayQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getCourseCompletionsReportAggregateByDayQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetCourseCompletionsReportAggregateByDayStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
